/* eslint-disable max-len */
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { SecondaryNavContent } from '../../models/app-data-model';

export type NavColumn = {
  index: number;
  content: SecondaryNavContent[];
};

/**
 * This hook is meant to take a SecondaryNavContent array and project it into a column array
 * This helps us more easily support column-ends
 *
 * @param {SecondaryNavContent[]} secondaryNavContent
 * @returns {[NavColumn[], Dispatch<SetStateAction<SecondaryNavContent[]>>]}
 */
function useColumnEnd(secondaryNavContent: SecondaryNavContent[]): [NavColumn[], Dispatch<SetStateAction<SecondaryNavContent[]>>] {
  const sortColumns = (content: SecondaryNavContent[]): NavColumn[] => {
    let currentColumnContent: SecondaryNavContent[] = [];
    let columnIndex = 0;
    const localColumns: NavColumn[] = [];

    content?.forEach((c, index) => {
      // Conditional will pass if we find a column end, or whenever we hit the last index of the array
      if (c.column_end || index === allContent.length - 1) {
        // When we treat the last index of the array as a column end we still want to push the element
        if (!c.column_end) {
          currentColumnContent.push(c);
        }
        const column = { index: columnIndex, content: currentColumnContent } as NavColumn;
        localColumns.push(column);
        // Set the next column start index to be the next value in the array
        columnIndex++;
        currentColumnContent = [];
      } else {
        currentColumnContent.push(c);
      }
    });

    return localColumns;
  };

  const [allContent, setContent] = useState(secondaryNavContent);
  const [columns, setColumns] = useState(sortColumns(allContent));

  useEffect(() => {
    setColumns(sortColumns(allContent));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allContent]);

  return [columns, setContent];
}

export default useColumnEnd;
